export interface DateValue {
  date: Date;
  value: number;
}

export const shortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const longMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function toLocaleDateTimeString(dateParm: undefined | string | Date) {
  if (!dateParm) return '';

  let date: Date;
  if (typeof dateParm === 'string') {
    date = new Date(dateParm);
  } else {
    date = dateParm;
  }

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}
